module.exports = __webpack_public_path__ + "static/img/br_legs_ok.748a239b.webp";